module.exports = __webpack_public_path__ + "static/img/day_report_win.ff697744.png";